//@flow
import * as Immutable from 'immutable';
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo

export type BeatPlanEditsModelType = {
    actor: {
        id: string
    },
    editedOn: string,
    edits: Array<FpEditsModelType>
};

export type FpEditsModelType = {
    editType: string,
    sourceBeatId: string,
    targetBeatId: ?string,
    visitId: string
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class BeatPlanEdits extends ImmutableModel {
    static fromJS(json: BeatPlanEditsModelType): BeatPlanEdits {
        const state: Object = Object.assign({}, json);
        state.edits = Immutable.List(state.edits).map(item =>
            FpEdits.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): BeatPlanEditsModelType {
        return {
            actor: this.actor,
            editedOn: this.editedOn,
            edits: this.edits.toArray().map(item => item.toJS())
        };
    }

    get actor(): { id: string } {
        return this._state.get('actor');
    }

    setActor(actor: { id: string }): this {
        return this.clone(this._state.set('actor', actor));
    }

    get editedOn(): string {
        return this._state.get('editedOn');
    }

    setEditedOn(editedOn: string): this {
        return this.clone(this._state.set('editedOn', editedOn));
    }

    get edits(): Immutable.List<FpEdits> {
        return this._state.get('edits');
    }

    setEdits(edits: Immutable.List<FpEdits>): this {
        return this.clone(this._state.set('edits', edits));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class FpEdits extends ImmutableModel {
    static fromJS(json: FpEditsModelType): FpEdits {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): FpEditsModelType {
        return {
            editType: this.editType,
            sourceBeatId: this.sourceBeatId,
            targetBeatId: this.targetBeatId,
            visitId: this.visitId
        };
    }

    get editType(): string {
        return this._state.get('editType');
    }

    setEditType(editType: string): this {
        return this.clone(this._state.set('editType', editType));
    }

    get sourceBeatId(): string {
        return this._state.get('sourceBeatId');
    }

    setSourceBeatId(sourceBeatId: string): this {
        return this.clone(this._state.set('sourceBeatId', sourceBeatId));
    }

    get targetBeatId(): ?string {
        return this._state.get('targetBeatId');
    }

    setTargetBeatId(targetBeatId: ?string): this {
        return this.clone(this._state.set('targetBeatId', targetBeatId));
    }

    get visitId(): string {
        return this._state.get('visitId');
    }

    setVisitId(visitId: string): this {
        return this.clone(this._state.set('visitId', visitId));
    }
}
